export const parseEmailDomain = (email: string): string | boolean => {
  const atIndex = email.indexOf('@');
  if (atIndex < 0) return false;
  const domain = email.substring(atIndex + 1);
  if (!domain) return false;
  const dotIndex = domain.indexOf('.');
  if (dotIndex < 0) return false;
  return domain;
};
